const GOOGLE_OAUTH_AUTHORIZE_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  '608220072929-esou9hvf2m3iv12f0l18j7t31eh6ks72.apps.googleusercontent.com';

// Must stay the n8n webhook that exchanges the code for tokens.
const GOOGLE_REDIRECT_URI =
  import.meta.env.VITE_GOOGLE_REDIRECT_URI ||
  'https://n8n.hireportal.ai/webhook/google_callback';

const GOOGLE_OAUTH_SCOPE = 'https://www.googleapis.com/auth/calendar';

/** n8n should HTTP-redirect the browser here after saving tokens. */
export const getGoogleOAuthSuccessUrl = () => {
  const configured = import.meta.env.VITE_GOOGLE_OAUTH_SUCCESS_URL;
  if (configured) return configured;
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/integrations/google/callback`;
  }
  return null;
};

/**
 * Build Google OAuth authorize URL. `state` is user_profiles.id for the n8n callback.
 *
 * Template:
 * https://accounts.google.com/o/oauth2/v2/auth?client_id=...&redirect_uri=https://n8n.hireportal.ai/webhook/google_callback&response_type=code&state=USER_ID&access_type=offline&prompt=consent&scope=https://www.googleapis.com/auth/calendar
 */
export const buildGoogleCalendarOAuthUrl = (userProfileId) => {
  if (!userProfileId || !GOOGLE_CLIENT_ID) return null;

  const state = encodeURIComponent(String(userProfileId));

  return (
    `${GOOGLE_OAUTH_AUTHORIZE_URL}`
    + `?client_id=${GOOGLE_CLIENT_ID}`
    + `&redirect_uri=${GOOGLE_REDIRECT_URI}`
    + '&response_type=code'
    + `&state=${state}`
    + '&access_type=offline'
    + '&prompt=consent'
    + `&scope=${GOOGLE_OAUTH_SCOPE}`
  );
};
